import { render, staticRenderFns } from "./SinglesDay2020.vue?vue&type=template&id=61c3630b&scoped=true&"
import script from "./SinglesDay2020.vue?vue&type=script&lang=js&"
export * from "./SinglesDay2020.vue?vue&type=script&lang=js&"
import style0 from "./SinglesDay2020.vue?vue&type=style&index=0&id=61c3630b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3630b",
  null
  
)

export default component.exports